/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { createContext } from '@googleforcreators/react';
import type { Story } from '@googleforcreators/elements';

/**
 * Internal dependencies
 */
import type { HistoryProviderState } from '../../types';

export default createContext<HistoryProviderState>({
  state: {
    currentEntry: {
      selection: [],
      capabilities: {},
      story: {} as Story,
      pages: [],
      current: null,
    },
    hasNewChanges: false,
    requestedState: null,
    canUndo: false,
    canRedo: false,
    versionNumber: 0,
  },
  actions: {
    stateToHistory: () => null,
    clearHistory: () => null,
    resetNewChanges: () => null,
    undo: () => false,
    redo: () => false,
  },
});
